import React from 'react';
import dayjs from 'dayjs';
import { RecordType } from '../types';
import './index.scss';

const RISK_CONCLUDE = {
    1: '有风险',
    2: '无风险',
    3: '待处理'
}

const RISK_TYPES_NAMES = {
    'LOSS_TIMES': '出险频次',
    'LOSS_RATE': '出险率',
    'LOSS_RATE_RANKING': '出险率排行',
    'DAMAGE_RANKING': '物损率排行',
    'CASE_DELAY_RANKING': '迟报率排行',
    'CASE_DELAY': '案件迟报',
    'JD_RISK': '京东预警',
};

interface ICardProps {
    data: RecordType,
    isSelected: boolean,
    onClick: () => void
}

const Card: React.FC<ICardProps> = props => {
    const { onClick, isSelected, data } = props;

    return (
        <div className={`card ${isSelected ? 'active' : ''} ${data.status === 1 ? 'finish' : 'todo'}`} onClick={onClick}>
            <div className="card-title">
                {
                    data.level?._id ? <span className="level" style={{ backgroundColor: data.level.bgColor }}>{data.level.levelName}风险</span> : null
                }
                <span className="titleText">{RISK_TYPES_NAMES[data.riskType as keyof typeof RISK_TYPES_NAMES]}</span>
                {/* 0:待处理，1: 已处理 */}
                <span className="state">{data.status === 1 ? '已处理' : '待处理'}</span>
            </div>
            <div className="card-content">
                <p>基础维度：{data.rule?.dimensions}</p>
                <p>满足条件：{data.rule?.conditions}</p>
            </div>
            <div className='card-time'>触发时间：{data.createTime ? dayjs(data.createTime).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
        </div>
    )
}

export default Card;